export const UNLAYER_MESSAGE = "edrone.unlayer-message";
